import "date-fns";
import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TableContainer,TableFooter
} from "@material-ui/core";
import Style from "../style.module.scss";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import getMuiTheme from "../misTheme";

const MaterialsReport = props => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [startDate, setStartDate] = useState(props.startDate);
  const [endDate, setEndDate] = useState(props.endDate);
  const [smallScreen, setSmallScreen] = useState(window.innerWidth <= 760);

  const [totalQuantity, setTotalQuantity] = useState([]);
  let columns = [];
  if (props.ReportFormat == "Material Wise") {
    columns = [
      {
        name: "mat",
        label: "Material Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "masadt",
        label: "Values",
        options: {
          filter: true,
          sort: true,
        },
      },
    ];
  } else if (props.ReportFormat == "Suppiler Wise") {
    columns = [
      {
        name: "mat",
        label: "Supplier Name",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "masadt",
        label: "Values",
        options: {
          filter: true,
          sort: true,
        },
      },
    ];
  }
  const tempQualityRes = (arr,elemIndex)=>{
    let totalQuantitytemp = [...totalQuantity]
    totalQuantitytemp[elemIndex]=0
    arr.map((item, index) => {
      if(item.number !='' ){
        if(item.number)
        totalQuantitytemp[elemIndex]=parseFloat(totalQuantitytemp[elemIndex])+parseFloat(item.number)
      }
      item.serial = index + 1;
    });
    return totalQuantitytemp;
  }
  useEffect(() => {
    const tempData = [];
    props.newWbs.forEach((elem, elemIndex) => {
      let totalQuantitytemp = tempQualityRes(elem.elm,elemIndex);

      let row = [];
      if (props.ReportFormat == "Material Wise") {
        row.push(
          elem.mat,
          <div>
            <MuiThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                data={elem.elm}
                columns={[  {
                  name: "serial",
                  label: "Serial No"
                 },{
                  name: "date",
                  label: "Date",
                },
                {
                  name: "supplier",
                  label: "Supplier",
                },
                {
                  name: "number",
                  label: "Quanity",
                },
                {
                  name: "unit",
                  label: "unit",
                },
                ]
                }
                options={{
                  selectableRows: "none",
                  responsive: smallScreen ? "scroll" : "simple",
                  pagination: false,
                  download: false,
                  viewColumns: false,
                  filter: true,
                  print: false,
                  setTableProps: () => ({className: "tableInside"}),
                  customFooter: (
                    ) => {
                      return (
                        <TableFooter>
                          <TableRow>
                            <TableCell variant="h4" colSpan={6} style={{float:'right',border:'none'}}>
                            Total Quantity:{totalQuantity[elemIndex] ? totalQuantity[elemIndex].toFixed(2):totalQuantitytemp[elemIndex].toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      );
                    },
                    onFilterChange: (changedColumn,filterList,type,changedColumnIndex,displayData)=>{
                      let templist= []
                      displayData.forEach(ele1 => {
                        templist.push({number:ele1.data[3]})
                      });
                      let totalequipmentQuantity = tempQualityRes(templist,elemIndex);

                      setTotalQuantity(totalequipmentQuantity)
                    }
                }}
              />
            </MuiThemeProvider>
          </div>
        );
      } else if (props.ReportFormat == "Suppiler Wise") {
        let totalQuantitytemp = tempQualityRes(elem.elm,elemIndex);

        row.push(
          elem.mat,
          <div>
            <MuiThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                data={elem.elm}
                columns={[  {
                  name: "serial",
                  label: "Serial No"
                 },{
                  name: "date",
                  label: "Date",
                },
                {
                  name: "material",
                  label: "Material",
                },
                {
                  name: "number",
                  label: "Quanity",
                },
                {
                  name: "unit",
                  label: "unit",
                },
                ]
                }
                options={{
                  selectableRows: "none",
                  responsive: smallScreen ? "scroll" : "simple",
                  pagination: false,
                  download: false,
                  viewColumns: false,
                  filter: true,
                  print: false,
                  setTableProps: () => ({className: "tableInside"}),
                  customFooter: (
                    ) => {
                      return (
                        <TableFooter>
                          <TableRow>
                            <TableCell variant="h4" colSpan={6} style={{float:'right',border:'none'}}>
                            Total Quantity:{totalQuantity[elemIndex] ? totalQuantity[elemIndex].toFixed(2):totalQuantitytemp[elemIndex].toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableFooter>
                      );
                    },
                    onFilterChange: (changedColumn,filterList,type,changedColumnIndex,displayData)=>{
                      let templist= []
                      displayData.forEach(ele1 => {
                        templist.push({number:ele1.data[3]})
                      });

                      let totalequipmentQuantity = tempQualityRes(templist,elemIndex);

                      setTotalQuantity(totalequipmentQuantity)
                    }
                }}
              />
            </MuiThemeProvider>
          </div>
        );
      }

      tempData.push(row);
    });

    setData(tempData);
  }, [totalQuantity]);

  return (
    <>
    
    <Grid container className={Style.container___info}>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              style={{ marginLeft: "0.5em" }}
            >
              Project Name:{props.projectName}
            </Typography>
          </Grid>
        </Grid>

        

        <div className={Style.table___box}>
          {props.newWbs !== undefined && (
            <MUIDataTable
              title={
                props.ReportFormat == "Material Wise"
                  ? `Material wise supplier report`
                  : "Supplier wise Material  report"
              }
              data={data}
              columns={columns}
              options={{
                selectableRows: "none",
                responsive: smallScreen ? "standard" : "simple",
                pagination: false,
                download: false,
                viewColumns: false,
                filter: false,
                print: false,
              }}
            />
          )}
        </div>
     
    </>
  );
};
export default MaterialsReport;
